import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { KintoneExportReportDetailContent } from "../../../../organisms/kintone-export/kintone-export-report-detail-content";
import {
  useKintoneExportReportDetailPage,
  useKintoneExportErrorDetails,
  useReExportErrorSubmission,
} from "../page-hooks/kintone-export-report-detail/hook";
import { KintoneExportTemplate } from "../template";
import { useKintoneExportSettingDetailPage } from "../page-hooks/kintone-export-setting-detail/hook";
import { useAuthContextV2 } from "../../../../../auth-state";
import { KintoneExportR } from "../routes";
import { KintoneExportReport } from "@graffer-inc/cloud-gov-core";

export const KintoneExportReportDetailPage: React.FC = () => {
  const { kintoneExportReportId, kintoneExportSettingId } = useParams<{
    kintoneExportSettingId: string;
    kintoneExportReportId: string;
  }>();
  const { auth } = useAuthContextV2();
  const { pageContent } = useKintoneExportReportDetailPage({
    kintoneExportSettingId,
    kintoneExportReportId,
  });

  const { kintoneExportErrorDetails } = useKintoneExportErrorDetails({
    kintoneExportReportId,
  });

  const { manualExportSubmission } = useKintoneExportSettingDetailPage({
    kintoneExportSettingId,
    tenantId: auth.data?.orgId,
  });

  const history = useHistory();
  const moveToReportDetail = React.useCallback(
    (kintoneExportReportId: KintoneExportReport["id"]) => {
      history.push(
        KintoneExportR.KintoneExportReportDetail.link({
          kintoneExportSettingId,
          kintoneExportReportId,
        }),
      );
    },
    [history, kintoneExportSettingId],
  );

  const { reExportErrorSubmission, isReExporting } = useReExportErrorSubmission(
    {
      manualExportSubmission,
      moveToReportDetail,
    },
  );

  return (
    <KintoneExportTemplate
      breadcrumbs={[
        {
          to: KintoneExportR.KintoneExportSettings.link({
            kintoneExportSettingId,
          }),
          title: "連携設定一覧",
        },
        {
          to: KintoneExportR.KintoneExportSettingDetail.link({
            kintoneExportSettingId,
          }),
          title:
            pageContent?.kintoneExportSetting.name ?? kintoneExportSettingId,
        },
        {
          to: KintoneExportR.KintoneExportReportDetail.link({
            kintoneExportSettingId,
            kintoneExportReportId,
          }),
          title: `実行記録#${kintoneExportReportId}`,
        },
      ]}
    >
      {!!pageContent && (
        <KintoneExportReportDetailContent
          kintoneExportReport={pageContent.kintoneExportReport}
          kintoneExportSetting={pageContent.kintoneExportSetting}
          kintoneExportErrorDetails={kintoneExportErrorDetails}
          reExportErrorSubmission={reExportErrorSubmission}
          isReExporting={isReExporting}
        />
      )}
    </KintoneExportTemplate>
  );
};
